<template>
  <div>
    <h6 class="heading-small text-muted mb-4 text-truncate">
      <span v-if="itemData === null">Add Item Inventory</span>
      <span v-else>Edit Item Inventory</span>
    </h6>

    <form id="form-proper">
      <div class="py-2" style="border-bottom: 1px solid #e0e0e0">
        <div class="row">
          <div class="col">
            <base-input label="Site" required>
              <a-select
                v-model="formData.site_id"
                @change="onChangeSite"
                :disabled="viewMode || itemData != null"
              >
                <a-select-option
                  v-for="site in options.sites"
                  v-bind:value="site.id"
                  v-bind:key="site.id"
                >
                  {{ site.name }}
                </a-select-option>
              </a-select>
              <div v-if="$v.formData.site_id.$dirty" class="text-danger">
                <div class="error" v-if="!$v.formData.site_id.required">
                  Field is required
                </div>
              </div>
            </base-input>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <base-input label="Item Code" required>
              <a-select
                v-if="itemData == null"
                v-model="formData.item_id"
                @change="onChangeItem"
                :disabled="viewMode || itemData != null"
              >
                <a-select-option
                  v-for="item in options.items"
                  v-bind:value="item.id"
                  v-bind:key="item.id"
                >
                  {{ item.code }}
                </a-select-option>
              </a-select>
              <div v-if="$v.formData.item_id.$dirty" class="text-danger">
                <div class="error" v-if="!$v.formData.item_id.required">
                  Field is required
                </div>
              </div>

              <a-input
                v-if="itemData != null"
                v-model.trim="code"
                :disabled="true"
              />
            </base-input>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <base-input label="Item Description">
              <a-input v-model.trim="formData.description" :disabled="true" />
            </base-input>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <base-input label="Inventory" required>
              <a-input-number
                class="w-100"
                v-model.trim="$v.formData.inventory_count.$model"
                :disabled="viewMode || itemData != null"
              />
              <div
                v-if="$v.formData.inventory_count.$dirty"
                class="text-danger"
              >
                <div class="error" v-if="!$v.formData.inventory_count.required">
                  Field is required
                </div>
              </div>
            </base-input>
          </div>
        </div>
        <div class="container-fluid p-0" v-if="!viewMode && itemData != null">
          <hr class="mt-3" />
          <h5>Inventory Update</h5>
          <div class="px-5">
            <div class="row">
              <div class="col-sm-6">
                <base-input label="Type">
                  <a-select v-model="formData.type">
                    <a-select-option value="add"> Add </a-select-option>
                    <a-select-option value="subtract">
                      Subtract
                    </a-select-option>
                  </a-select>
                </base-input>
              </div>
              <div class="col-sm-6">
                <base-input label="Quantity" required>
                  <a-input-number
                    @keyup="quantityUpdate"
                    class="w-100"
                    v-model.trim="formData.quantity"
                  />
                  <div v-if="$v.formData.quantity.$dirty" class="text-danger">
                    <div class="error" v-if="!$v.formData.quantity.required">
                      Field is required
                    </div>
                  </div>
                </base-input>
              </div>

              <div class="col-sm-12">
                <base-input label="Reason for Update" required>
                  <a-input v-model.trim="$v.formData.notes.$model" />
                  <div v-if="$v.formData.notes.$dirty" class="text-danger">
                    <div class="error" v-if="!$v.formData.notes.required">
                      Field is required
                    </div>
                  </div>
                </base-input>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        style="
          position: absolute;
          bottom: 0px;
          right: 0px;
          width: -webkit-fill-available;
          background-color: #f2f2f2;
          padding: 10px;
        "
      >
        <div class="container mx-0 px-0">
          <div class="row">
            <div class="col-auto mr-auto">
              <b-button
                size="sm"
                class="float-md-left"
                style="margin-left: 8px"
                @click.prevent="closeDrawer()"
              >
                Cancel
              </b-button>
            </div>
            <div class="col-auto">
              <template>
                <a-spin :spinning="formSubmitting">
                  <b-button
                    v-if="itemData === null"
                    size="sm"
                    variant="primary"
                    @click.prevent="createItem"
                  >
                    Save
                  </b-button>

                  <b-button
                    v-else
                    size="sm"
                    variant="primary"
                    @click.prevent="updateItem"
                    :disabled="viewMode"
                  >
                    Save
                  </b-button>
                </a-spin>
              </template>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { required, requiredIf } from 'vuelidate/lib/validators';
import HTTPRequest from '../../controllers/httpRequest';

export default {
  name: 'ItemInventoryForm',
  props: {
    itemData: Object,
    viewMode: Boolean
  },

  data() {
    return {
      formSubmitting: false,
      totalQuantity: 0,
      code: '',
      items: [],
      formData: {
        membership_program_id: null,
        item_id: null,
        site_id: null,
        description: null,
        inventory_count: 0,
        notes: null,
        quantity: 0,
        type: 'add'
      },
      options: {
        items: [],
        sites: []
      }
    };
  },

  validations: {
    formData: {
      item_id: { required },
      description: {
        required: requiredIf(function () {
          return this.itemData === null;
        })
      },
      site_id: { required },
      inventory_count: {
        required
      },
      notes: {
        required: requiredIf(function () {
          return this.itemData !== null;
        })
      },
      quantity: {
        required
      }
    }
  },

  methods: {
    async onChangeSite(site) {
      this.formData.item_id = null;
      this.formData.description = null;
      await this.getItems(site);
    },
    quantityUpdate() {
      let quantity = parseInt(this.formData.quantity);
      if (isNaN(quantity)) {
        quantity = 0;
      }
      if (quantity) {
        if (this.formData.type === 'add') {
          this.totalQuantity = this.formData.inventory_count + quantity;
        } else {
          this.totalQuantity = this.formData.inventory_count - quantity;
        }
      }
    },
    onChangeItem(data) {
      const item = this.options.items.find((item) => item.id === data);
      if (item) {
        this.formData.membership_program_id = item.membership_program_id;
        this.formData.description = item.description;
      }
    },
    async getItems(site) {
      const response = await HTTPRequest.getRequest(
        '/api/v1/site_item_inventories?site_id=' + site,
        {
          per_page: 1000
        }
      );

      const itemIdsToDelete = new Set(
        response.data.map((item) => item.item_id)
      );
      this.options.items = this.items
        .filter((item) => !itemIdsToDelete.has(item.id))
        .sort((a, b) => a.code.localeCompare(b.code));
    },
    async getAllItems() {
      const response = await HTTPRequest.getRequest(
        '/api/v1/clp_items?status_code=A',
        {
          per_page: 1000
        }
      );
      this.items = response.data.sort((a, b) => a.code.localeCompare(b.code));
    },

    async getSites() {
      const response = await HTTPRequest.getRequest('/api/v1/sites', {
        per_page: 1000
      });
      this.options.sites = response.data.sort((a, b) =>
        a.name.localeCompare(b.name)
      );
    },

    async createItem() {
      this.$v.formData.$touch();

      if (!this.$v.formData.$invalid) {
        this.formSubmitting = true;

        const response = await HTTPRequest.postRequest(
          '/api/v1/site_item_inventories',
          {
            site_item: this.formData
          }
        );

        if (response.id) {
          this.closeDrawer();
          this.$root.$emit('refreshTable');
          this.$notification.success({
            message: 'Data has been created.'
          });
        } else {
          if (response.error != undefined) {
            this.$notification.error({
              message: response.error
            });
          } else {
            this.$notification.error({
              message: 'Something went wrong. Please try again.'
            });
          }
        }

        this.formSubmitting = false;
      }
    },

    async updateItem() {
      this.$v.formData.$touch();

      if (!this.$v.formData.$invalid) {
        if (this.formData.type !== 'add' && this.totalQuantity < 0) {
          this.$notification.error({
            message:
              'The total inventory count is negative.Please check type field'
          });
          return;
        }

        this.formSubmitting = true;
        const response = await HTTPRequest.putRequest(
          '/api/v1/site_item_inventories/' + this.itemData.id,
          {
            site_item: this.formData
          }
        );

        if (response.id) {
          this.closeDrawer();
          this.$root.$emit('refreshTable');
          this.$notification.success({
            message: 'Data has been updated.'
          });
        } else {
          if (response.error != undefined) {
            this.$notification.error({
              message: response.error
            });
          } else {
            this.$notification.error({
              message: 'Something went wrong. Please try again.'
            });
          }
        }

        this.formSubmitting = false;
      }
    },

    closeDrawer() {
      this.clearForm();
      this.$emit('closeDrawer', null);
      this.$v.formData.$reset();
    },

    clearForm() {
      this.code = '';
      this.formData = {
        item_id: null,
        site_id: null,
        description: null,
        inventory_count: 0,
        notes: null,
        membership_program_id: null,
        quantity: 0,
        type: 'add'
      };
    },

    setFormData(data) {
      this.clearForm();
      if (this.itemData !== null) {
        const membership_program_id = data?.item?.membership_program_id;
        const quantity = 0;
        const type = 'add';
        this.code = data?.item?.code;
        const { item_id, site_id, description, inventory_count } = data;
        this.formData = {
          membership_program_id,
          item_id,
          site_id,
          description,
          inventory_count,
          quantity,
          type
        };
      }
    }
  },

  created: async function () {
    await this.getSites();
    await this.getAllItems();
    this.setFormData(this.itemData);
  },

  watch: {
    itemData: function (data) {
      this.clearForm();
      if (data !== null) {
        this.setFormData(data);
      }
    }
  }
};
</script>

<style scoped></style>
